var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "app-dialer-common-popup",
      style: _vm.componentStyle,
      attrs: { "data-popup": "" },
    },
    [
      _c("div", { staticClass: "header", attrs: { "data-popup": "" } }, [
        _c("div", { staticClass: "title", attrs: { "data-popup": "" } }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "icon-button",
            class: { "is-disabled": _vm.isDisabled },
            attrs: { "data-action": "close" },
            on: { click: _vm.onClose },
          },
          [_c("or-icon", { attrs: { icon: "close" } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content", class: { "is-loading": _vm.isLoading } },
        [
          _vm.isLoading
            ? _c("or-loader", { attrs: { type: "circle", "is-loading": "" } })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading ? _vm._t("default") : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }